export const prompts = [
    "What’s your earliest memory of money, and how does it influence your financial decisions today?",
    "If money were no object, how would your daily life change?",
    "What is the best financial advice you’ve ever received?",
    "What’s a recent financial decision you’re proud of?",
    "What limiting belief about money are you currently working to overcome?",
    "How do you define financial success?",
    "What’s the most valuable thing you’ve learned about money from a mentor or role model?",
    "How do you balance saving for the future with enjoying the present?",
    "What is one area of personal finance you’d like to understand better?",
    "What’s the biggest money mistake you’ve ever made, and what did you learn from it?",
    "How do you typically react to unexpected expenses?",
    "What’s a financial habit you’ve developed that has made the biggest positive impact?",
    "If you could go back in time, what financial advice would you give your younger self?",
    "What emotions do you feel when you check your bank account balance?",
    "What’s a purchase that felt expensive but was worth every penny?",
    "How do you approach financial conversations with friends or family?",
    "What’s your favorite way to treat yourself without overspending?",
    "How do you stay motivated to work toward your financial goals?",
    "What is one financial decision you’d make differently if you had the chance?",
    "What does living a wealthy life mean to you beyond just money?",
    "How does your current relationship with money reflect your values?",
    "What beliefs about money feel most true to you right now?",
    "How do you decide what’s worth spending money on today?",
    "What does financial abundance mean to you in your current life stage?",
    "What’s your biggest motivator for earning money right now?",
    "How do you feel about the balance between saving and spending in your life today?",
    "What’s one way your mindset about money is helping you grow?",
    "What do you believe is holding you back financially at this moment?",
    "How do you currently measure your financial success?",
    "What role does generosity play in your current financial decisions?",
    "How comfortable are you discussing money with others, and why?",
    "What emotions do you experience most often when you think about your finances?",
    "How do you decide when to say yes or no to a financial opportunity?",
    "What does living ‘within your means’ look like to you right now?",
    "How has your current financial situation shaped your priorities?",
    "What’s one financial habit that feels natural to you right now?",
    "What do you do when faced with a financial decision that feels uncertain?",
    "How do you currently feel about your ability to create wealth?",
    "What’s your go-to strategy for managing financial stress?",
    "How much control do you feel over your financial future, and why?",
    "What’s one way you actively practice gratitude for your financial situation?",
    "How do you ensure your financial goals align with your personal values today?",
    "What is one money-related decision you feel most confident about right now?",
    "What’s a belief about money you’re working to strengthen today?",
    "How do you currently feel about the role of debt in your financial strategy?",
    "What’s the most empowering part of your current financial mindset?",
    "What’s the biggest challenge you face in sticking to your financial goals today?",
    "How do you approach budgeting or tracking your finances in your current routine?",
    "What does financial independence mean to you in this season of your life?",
    "What is your relationship with risk in financial decisions right now?",
    "How do you balance personal enjoyment with financial responsibility?",
    "What’s a money habit you feel proud of in your life today?",
    "How do you prioritize spending on experiences versus things?",
    "What’s a belief about money that feels outdated for you now?",
    "How do you view investing in yourself financially at this moment?",
    "What’s one area of your financial life where you feel particularly confident?",
    "How do you make space for financial growth in your life today?",
    "What’s one way you could simplify your financial mindset right now?",
    "How does your current income reflect the value you bring to the world?",
    "What’s one financial decision you’re excited to make this year?",
    "How do you feel about your savings habits right now?",
    "What role does discipline play in your current financial mindset?",
    "What’s the most important financial boundary you’ve set recently?",
    "How do you evaluate whether an expense is worth it in the moment?",
    "What’s one belief about money that feels most empowering to you today?",
    "How do you incorporate self-care into your financial habits?",
    "What’s one area of your finances where you’d like to see more clarity?",
    "How do you balance optimism and caution in your financial outlook?",
    "What’s one small adjustment you could make to improve your money mindset?",
    "How do you approach financial setbacks in your current mindset?",
    "What’s your current definition of financial security?",
    "How do you ensure your financial decisions align with your long-term vision?",
    "What’s one way your money mindset helps you feel more in control?",
    "How do you define ‘enough’ for your financial goals today?",
    "What’s one belief about money that you feel deeply rooted in your life right now?",
    "How do you decide which financial opportunities to pursue?",
    "What’s one way you could feel more empowered about money today?",
    "How do you stay focused on your financial goals amidst distractions?",
    "What’s one financial strength you’re leveraging at this moment?",
    "How does your current money mindset influence your daily decisions?",
    "What’s one financial boundary you’re proud of maintaining?",
    "How do you decide when to spend versus when to save?",
    "What’s one financial habit you’ve adopted that feels impactful right now?",
    "How do you feel about the balance of effort and reward in your finances today?",
    "What’s one money belief that grounds you in the present moment?",
    "How do you navigate feelings of comparison regarding others’ finances?",
    "What’s the most exciting part of your current financial journey?",
    "How do you manage the tension between stability and ambition in your finances?",
    "What’s one financial goal that feels most aligned with your values today?",
    "How do you ensure your spending reflects what truly matters to you?",
    "What’s one financial mindset shift that has improved your life recently?",
    "How do you stay mindful of your financial goals during daily decisions?",
    "What’s one area of your finances where you feel particularly challenged right now?",
    "How do you approach learning about money in your current season?",
    "What’s the most fulfilling part of your financial mindset today?",
    "How do you decide what’s worth investing in for your future?",
    "What’s one way you could celebrate your financial progress right now?",
    "How do you evaluate the balance between earning, saving, and giving?",
    "What does living a financially intentional life look like for you today?",
    "What’s one belief about money you feel is empowering your current goals?",
    "How do you ensure your money habits support your personal growth?",
    "What’s one way you’re actively nurturing an abundance mindset right now?",
    "How do you align your financial actions with your personal definition of success?",
    "What’s one financial boundary you’d like to strengthen today?",
    "How do you approach opportunities that could stretch your financial comfort zone?",
    "What’s one financial practice that makes you feel grounded right now?",
    "How do you stay motivated to keep improving your money mindset?",
    "What’s one way you could improve your financial mindfulness today?",
    "How does your current money mindset influence your relationships?",
    "What’s one financial decision you feel really proud of making recently?",
    "How do you ensure your money supports your life, rather than the other way around?",
    "What’s one financial goal that excites you the most at this moment?",
    "How do you feel about the role of money in creating freedom?"
];
